const styles = {
  // max width
  maxWidth: 'max-w-[1200px] mx-auto px-[17px] md:px-[35px]',
  // hero section
  heroHome: 'h-[40vh] md:h-screen bg-hero-home bg-no-repeat bg-cover bg-center',
  // home section four
  homeSectionFour:
    'h-[40vh] md:h-[80vh] bg-hero-home bg-no-repeat bg-cover bg-fixed',
  // hero services
  heroServices:
    'h-[40vh] md:h-screen bg-hero-services bg-no-repeat bg-cover bg-center',
  // footer bg image
  footerBgImg: 'md:h-screen bg-footer bg-no-repeat bg-cover',
  // heading
  heroHeading:
    'xxs:text-[1.2rem] xs:text-[1.6rem] sm:text-[2rem] md:text-[4rem] leading-[1.2] font-bold mb-8',
  heroHeadingTwo:
    'text-[2rem] md:text-[4rem] text-start leading-[1.2] font-bold md:mb-8',
  headerTwoBlack:
    'text-blackText xxs:text-[1.2rem] xs:text-[1.4rem] sm:text-[1.8rem] md:text-[2.5rem] leading-[1.2] font-bold mb-8',
  headerTwoWhite:
    'text-white xxs:text-[1.2rem] xs:text-[1.4rem] sm:text-[1.8rem] md:text-[2.5rem] leading-[1.2] font-bold mb-3 md:mb-8',
  headerFourBlack:
    'text-blackText xxs:text-[1rem] xs:text-[1.4rem] sm:text-[1.6rem] md:text-[2rem] leading-[1.2] font-bold mb-8',
  headerTwoPrimary:
    'text-primary xxs:text-[1.2rem] xs:text-[1.4rem] sm:text-[1.8rem] md:text-[2rem] leading-[1.2] font-bold mb-4 md:mb-8',
  headerThreeBlack:
    'text-blackText xs:text-[1.1rem] sm:text-[1.2rem] md:text-[1.3rem] leading-[1.2] font-bold mb-2',
  headerThreeWhite:
    'text-white xs:text-[1.1rem] sm:text-[1.2rem] md:text-[1.5rem] leading-[1.2] font-bold mb-2',
  // button
  buttonOne:
    'flex items-center w-max bg-primary px-3 py-1 md:px-5 md:py-3 rounded-xl hover:bg-primaryAlt',
  buttonTwo:
    'flex items-center w-max bg-primary px-3 py-1 md:px-5 md:py-2 hover:bg-primaryAlt',
  buttonThree:
    'bg-[rgba(0,0,0,0.1)] px-3 py-1 rounded-lg hover:bg-[rgba(0,0,0,0.2)] font-semibold cursor-pointer w-max h-max',
  buttonFour:
    'bg-primary text-white px-3 py-1 rounded-lg hover:bg-primaryAlt font-semibold cursor-pointer w-max h-max',
  formInput:
    'mt-3 w-full h-[40px] placeholder:font-semibold focus:outline-none p-2 bg-white border rounded-md focus:border-[3px] focus:border-blue-500',
  formButton:
    'w-full h-[40px] bg-primaryBackground hover:bg-blue-700 text-white font-semibold rounded-md active:bg-blue-500',
};

export default styles;
